import activity from './activity.json';
import assets from './assets.json';
import auth from './auth.json';
import commissions from './commissions.json';
import common from './common.json';
import dashboard from './dashboard.json';
import payouts from './payouts.json';
import profile from './profile.json';
import rewards from './rewards.json';
import shareLink from './shareLink.json';
import stats from './stats.json';

const es_419 = {
  activity,
  assets,
  auth,
  commissions,
  common,
  dashboard,
  payouts,
  profile,
  rewards,
  shareLink,
  stats,
};

export default es_419;
